<template>
  <b-modal :active="value" has-modal-card @close="close()">
    <!-- 災害情報結合 -->
    <form v-if="value" action="">
      <div class="modal-card" style="width: 800px; min-hight: 500px">
        <header class="modal-card-head">
          <p class="modal-card-title" style="color: whitesmoke">災害情報結合</p>
        </header>

        <section class="modal-card-body">
          <b-field label="登録日" labelPosition="on-border">
            <b-input
              v-model="disasterList[0].entryDate"
              expanded
              data-vv-as="登録日"
              :readonly="true"
            ></b-input>
          </b-field>

          <b-field label="支店名" labelPosition="on-border">
            <b-input
              v-model="disasterList[0].branchName"
              expanded
              data-vv-as="支店名"
              :readonly="true"
            ></b-input>
          </b-field>

          <b-field
            label="災害名"
            labelPosition="on-border"
            :type="{ 'is-danger': errors.has('disasterName') }"
            :message="errors.first('disasterName')"
          >
            <b-input
              v-model="data.disasterName"
              name="disasterName"
              expanded
              data-vv-as="災害名"
              v-validate="'required'"
              maxlength="100"
            >
            </b-input>
          </b-field>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="save">決定</button>
          <button class="button" type="button" @click="close()">閉じる</button>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
export default {
  props: {
    disasterList: {
      type: Array,
      default: function () {
        return [{}];
      },
    },
    value: {
      type: Boolean,
      defalt: false,
    },
  },

  components: {},

  data() {
    return {
      data: {
        disasterName: null,
      },
    };
  },

  computed: {},

  filters: {},

  methods: {
    save: async function () {
      // バリデーション
      const validateRes = await this.$validator.validateAll();
      if (!validateRes) {
        return;
      }

      // 災害結合API実行
      this.apiCall(this.joinPOST, this.joinPOSTSuccess, this.joinPOSTError);

      return;
    },

    close: function () {
      this.$emit("input", false);
      return;
    },

    joinPOST: function (client) {
      // パラメータ準備
      const disasterIdList = [];
      for (const disaster of this.disasterList) {
        disasterIdList.push(disaster.disasterId);
      }

      // 災害結合API実行
      const apiRes = client.apis.apiDisaster.joinPOST({
        body: {
          disasterIdList: disasterIdList,
          disasterName: this.data.disasterName,
        },
      });
      return apiRes;
    },

    joinPOSTSuccess: function (result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      this.$emit("joined");
      this.close();
      return;
    },

    joinPOSTError: function (result) {
      // 失敗メッセージ表示
      this.showErrorMessage(result);
      return;
    },
  },

  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/common/DisasterJoin.vue